import React, { PureComponent } from "react";
import { Link, Route, withRouter, RouteComponentProps, Redirect, Switch } from "react-router-dom";
import styled from "styled-components";
import { withContext } from "../../contexts";
import { hot } from "react-hot-loader";
import Login from "../../pages/login";
import { UserState, UserContext } from "../../contexts/user";
import { AdaptBody } from "../../components";
import { MapboxProvider } from "@gago-react-gl/gago-react-gl";
import { BigScreen } from "../../pages/big-screen";
import HomeHeader from "../../pages/home-header";
import VillageScreen from "../../pages/village-screen";
import VideoList from "../../pages/video-list";

// tslint:disable:jsx-no-lambda jsx-no-multiline-js
// tslint:disable:variable-name jsx-alignment

const RootStyle = styled.div`
  width: 100%;
  height: 100%;
`;

/**
 * 应用入口
 * @author 张卓诚
 * @author 马俊峰
 * @date 2020-07-21
 * @class App
 * @extends {(PureComponent<RouteComponentProps & UserState>)}
 */
class App extends PureComponent<RouteComponentProps & UserState> {
  state = {
  };
  render() {
    return (
      <RootStyle>
        <MapboxProvider>
          <AdaptBody designHeight={1080} designWidth={1920} adaptive equalProportion={false}>
            {(this.props.isLogin && this.props.user) ?
              <Switch>
                <Route path="/" render={({ location, history, match }) => (
                  <HomeHeader location={location} history={history} match={match}>
                    <Switch>
                      <Route path={`${match.path}big-screen`} component={BigScreen} />
                      <Route path={`${match.path}village-screen`} component={VillageScreen} />
                      <Route path={`${match.path}video-list`} component={VideoList} />
                      <Redirect exact path="/" to="/big-screen" />
                    </Switch>
                  </HomeHeader>
                )}/>
              </Switch>
            : <Login/>}
          </AdaptBody>
        </MapboxProvider>
      </RootStyle >
    );
  }
}

export default withRouter(withContext(UserContext)(App));
// export default hot(module)(withRouter(withContext(UserContext)(App)));
